import * as React from "react";
import { FluentProvider, webLightTheme, webDarkTheme } from "@fluentui/react-components";

export const ThemeContext = React.createContext({
  theme: null,
  isDarkTheme: true,
  changeTheme: (_isDark) => {},
});

export default function ThemeContextProvider({ children }) {
  const _isDarkTheme = Office.context.officeTheme?.isDarkTheme ?? false;
  const [isDarkTheme, setIsDarkTheme] = React.useState(_isDarkTheme);

  const changeTheme = (isDark: boolean) => {
    setIsDarkTheme(isDark);
  };

  const ctx = {
    theme: isDarkTheme ? webDarkTheme : webLightTheme,
    isDarkTheme,
    changeTheme,
  };

  return (
    <ThemeContext.Provider value={ctx}>
      <FluentProvider theme={ctx.theme}>{children}</FluentProvider>
    </ThemeContext.Provider>
  );
}
